// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2PDCS","messages":"Chat_messages__pi2-Y","dateDivider":"Chat_dateDivider__3pAIA"};